import { useContext } from 'react'
import { Stepper, StepperProps, rem } from '@mantine/core'
import QuizTimelineSpot from './QuizTimelineSpot'
import { QuizContext } from '@context/QuizContext'
import { breakpoints } from '@theme/breakpoints'

function StyledStepper(props: StepperProps) {
    return (
        <Stepper
            styles={{
                stepBody: {
                    display: 'none',
                },

                step: {
                    padding: 0,
                },

                stepIcon: {
                    borderWidth: rem(4),
                },

                separator: {
                    marginLeft: rem(-2),
                    marginRight: rem(-2),
                    height: rem(10),
                },
            }}
            {...props}
        />
    )
}

interface IQuizTimeline extends Omit<StepperProps, 'active' | 'children'> {
    active?: number
    children?: React.ReactNode
}
const QuizTimeline = ({ ...other }: IQuizTimeline) => {
    const { currentStep } = useContext(QuizContext)
    return (
        <StyledStepper
            display={{ xs: 'none', lg: 'block' }}
            mx='auto'
            maw={breakpoints.sm}
            active={currentStep! - 1}
            color='fuchasia.5'
            {...other}
        >
            <QuizTimelineSpot
                stepspot={1}
                active={currentStep!}
            ></QuizTimelineSpot>
            <QuizTimelineSpot
                stepspot={2}
                active={currentStep!}
            ></QuizTimelineSpot>
            <QuizTimelineSpot
                stepspot={3}
                active={currentStep!}
            ></QuizTimelineSpot>
            <QuizTimelineSpot
                stepspot={4}
                active={currentStep!}
            ></QuizTimelineSpot>
            <QuizTimelineSpot
                stepspot={5}
                active={currentStep!}
            ></QuizTimelineSpot>
            <QuizTimelineSpot
                stepspot={6}
                active={currentStep!}
            ></QuizTimelineSpot>
            {/* <QuizTimelineSpot
                stepspot={7}
                active={currentStep!}
            ></QuizTimelineSpot> */}

            {/* <Stepper.Step label='Step 1' description='Create an account' />
            <Stepper.Step label='Step 2' description='Verify email' />
            <Stepper.Step label='Step 3' description='Get full access' /> */}
        </StyledStepper>
    )
}

export default QuizTimeline
